import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../authentication/auth.service';
import { AngularTokenService } from 'angular-token';
import { Router, 
	       NavigationStart, 
	       NavigationEnd, 
	       NavigationError, 
	       NavigationCancel, 
	       ActivatedRoute , 
	       Params,  
	       Event as RouterEvent,} from '@angular/router';

import { ToastrService } from 'ngx-toastr';

declare var $:any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  
  currentUser:any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
  	) { }

  ngOnInit() {
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  isLoggedOut(): boolean {
    return !this.authService.isLoggedIn();
  }

  getUserData(){
    this.currentUser = {
      "id": localStorage.getItem('id'),
      "email": localStorage.getItem('email'),
    }
  }

  logout(): void {
    this.authService.logOut();
    this.toastr.success("Logged out successfully.");
  }

}
